module.exports = __webpack_public_path__ + "static/media/fountain.f4bf30a4.jpg";